<template>
  <div>
    <span v-if="icon&&defaultCell" :class="icon" @click="iconClick"></span>
    <span :style="userOldCell(scope?scope.row:'')?'':'color: #409EFF; cursor: pointer;'" @click="click">{{defaultCell}}</span>
    <span v-if="text&&defaultCell" style="color: #409EFF; cursor: pointer;padding:0 5px" :class="icon" @click="textClick">{{text}}</span>
  </div>
</template>
<script>
export default {
  name: 'cell-text-icon',
  props: {
    userOldCell:{
      type: Function,
      required: false,
      default() {
          return false;
      },
    },
    scope: Object,
    value: {
      type: [Object, String],
      required: false,
    },
    formatter: Function,
    icon:String,
    text:String,
  },
  computed: {
    defaultCell() {
      if(this.value){//表单
        if (typeof this.formatter == 'function') {
          return this.formatter(this.scope, this.scope.row[this.scope.column.property])
        }
        return this.value;
      }
      if(this.scope){//表格
        if (typeof this.formatter == 'function') {
          return this.formatter(this.scope, this.scope.row[this.scope.column.property])
        }
        return this.scope.row[this.scope.column.property]
      }
      return "";
    },
  },
  methods: {
    click(){
      if(this.userOldCell(this.scope.row)){
        return;
      }
      this.$emit('click', this.scope)
    },
    iconClick(){
      this.$emit('iconClick', this.scope)
    },
    textClick(){
      this.$emit('textClick', this.scope)
    }
  }
}
</script>